import Api from '../../api'
import axios from '@/js/api'
import router from '../../router'
import date from '../../js/date.js'
// import {Message}from 'element-ui'
const state = {
	hospitalResultParameter:{
		startdt:'',
		enddt:'',
		hospitalGuid:'',
		type:'' //报告2 影像1
	},
	hospitalResultList:[],
	//影像中心日期
	reportDate: {
		data: []
	},
	scoreAreaList:[],
	trigger:{
		flag:false
	},
	tableFlag:false,
	tabType:false
};
const getters = {};
const mutations = {
	setHospitalResult(state,res){
		state.trigger.flag = true;
		state.hospitalResultList = res.data;
	},
	setScoreArea(state,res){
		state.trigger.flag = true;
		state.scoreAreaList = res.data.ScoreAreas;
		let data = state.scoreAreaList;
		let num = 0;
		for (let i = 0; i < data.length; i++) {
			num += Number(data[i].ReportCount);
		}
		state.tableFlag = num == 0? false : true;
	},
	changeType(state,type){
		state.tabType = type;
	},
};
const actions = {
	 //影像中心能力
	GetHospitalResult({state,commit},arr) {
		return axios.ajaxGet('get', Api.api.supervisor.GetHospitalResult, state.hospitalResultParameter).then(res => {
			commit('setHospitalResult', res);
		}).finally(() => {});
	},
	 //分数及人员分布
	GetScoreArea({state,commit},arr) {
		state.hospitalResultParameter.doctorType = arr.doctorType;
		return axios.ajaxGet('get', Api.api.supervisor.GetScoreArea, state.hospitalResultParameter).then(res => {
			commit('setScoreArea', res);
		}).finally(() => {});
	},
};


export default {
	namespaced: true,
	state,
	getters,
	mutations,
	actions
}